import React from 'react'
import { translate } from 'react-i18next'
import ServiceItem from './Service'
import './index.sass'

const Services = ({ services, t }) => (
  <div className="services-container">
    <h3>{t('about.services.title')}</h3>
    <div className="services">
      {services.map((services, ind) => (
        <ServiceItem key={ind} keyForTranslation={ind} title={t(`about.services.${ind}.title`)} servicesList={services.servicesList} />
      ))}
    </div>
  </div>
)

export default translate('translations')(Services)
